import { CSSProperties } from "react";
import { withLiteObserverAndTheme } from "../et3-enhanced-render";

const Et3ATag = withLiteObserverAndTheme<{
  children?: React.ReactNode;
  href: string;
  target: "_blank" | "_self" | "_parent" | "_top" | "framename";
  style: CSSProperties;
}>((props) => {
  const { href, style, target, children } = props;

  return (
    <a
      href={href}
      target={target}
      rel="noreferrer"
      style={{ textDecoration: "auto", ...style }}
    >
      {children}
    </a>
  );
});

export default Et3ATag;
